export default "__VITE_ASSET__Dvh6mKzI__"